import { html as e, when as o } from "@microsoft/fast-element";
const i = e`
  ${o(
  (t) => t._time >= 0,
  e`
      <div class="control" part="control">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="-50 -50 100 100"
          fill="none"
        >
          <circle r="45" stroke-width="8" />
          <circle r="45" stroke-width="8" pathLength="1" />
          <text font-size="65" stroke-width="1">${(t) => t._time}</text>
        </svg>
      </div>
    `
)}
`;
export {
  i as timerTemplate
};
